/*
Copyright 2022-2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import { type FC } from "react";

import { Header, HeaderLogo, LeftNav, RightNav } from "../Header";
import commonStyles from "./common.module.css";
import { useUrlParams } from "../UrlParams";
import { SSOButton } from "../auth/SSOButton";

export const UnauthenticatedView: FC = () => {
  const { header } = useUrlParams();

  return (
    <>
      <div className={commonStyles.container}>
        {header === "standard" && (
          <Header>
            <LeftNav>
              <HeaderLogo />
            </LeftNav>
            <RightNav hideMobile>
            </RightNav>
          </Header>
        )}
        <main className={commonStyles.main}>
          <SSOButton />
        </main>
      </div>
    </>
  );
};
